import React, { useState, useCallback, useMemo, useEffect } from 'react';

import { LegacyBox, RadioGroup } from '@gogame/components';

import { SetAmount, UpdateAmount, AmountRadio, Preview } from './components';
import { SET_AMOUNT, UPDATE_AMOUNT } from './constants';
import { getNewAmount } from './helpers';

const capitalizeFirstLetter = (s) =>
  `${s.charAt(0).toUpperCase()}${s.slice(1)}`;

const AmountField = ({
  value,
  initial,
  onChange,
  unit = 'bid',
  withPreview = true,
  canUpdate = true,
  error,
  updateWarning,
}) => {
  const [action, setAction] = useState(SET_AMOUNT);

  const handleChangeAction = useCallback((_e, a) => setAction(a), []);
  const newAmount = useMemo(
    () => (value && initial !== undefined ? getNewAmount(initial, value) : ''),
    [initial, value]
  );

  useEffect(() => () => onChange({}, null), []);

  return (
    //TODO: remove <LegacyBox style={{ padding: '0 8px' }}> after migration html to Material
    <React.Fragment>
      <LegacyBox style={{ padding: '0 8px' }}>
        <RadioGroup
          value={action}
          onChange={handleChangeAction}
          title={capitalizeFirstLetter(`${unit} amount `)}
        >
          <LegacyBox gutter={16} vertical={true} style={{ marginTop: '8px' }}>
            <AmountRadio
              value={SET_AMOUNT}
              amount={value}
              component={SetAmount}
              key={'setAmount'}
              onChangeAmount={onChange}
              error={action === SET_AMOUNT ? error : undefined}
            />
            <AmountRadio
              value={UPDATE_AMOUNT}
              amount={value}
              component={UpdateAmount}
              key={'updatedAmount'}
              unit={unit}
              disabled={!canUpdate}
              onChangeAmount={onChange}
              warning={action === UPDATE_AMOUNT ? updateWarning : undefined}
              error={action === UPDATE_AMOUNT ? error : undefined}
            />
          </LegacyBox>
        </RadioGroup>
      </LegacyBox>
      {withPreview ? (
        <Preview initialValue={initial} value={newAmount} unit={unit} />
      ) : null}
    </React.Fragment>
  );
};

export default AmountField;
